import PropTypes from 'prop-types';
import Spinner from 'components/Spinner';
import { Bg, StyledContainer } from './styled';

const Container = ({ bg, children, variant, isLoading, className }) => {
  return (
    <Bg bg={bg} isLoading={isLoading}>
      {isLoading && <Spinner variant={variant} />}
      {!isLoading && <StyledContainer className={className}>{children}</StyledContainer>}
    </Bg>
  );
};

Container.propTypes = {
  bg: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light'])
};

Container.defaultProps = {
  bg: '',
  className: '',
  isLoading: false,
  children: null,
  variant: 'light'
};

export default Container;
